<form
  [formGroup]="form"
  [patchForm]="organization"
  (ngSubmit)="onFormSubmit()"
  *ngIf="
    (formFieldConfigs$ | async) &&
    (formFieldConfigs$ | async)?.length != 0 &&
    formConfigValidatorResult?.isValid
  "
>
  <div class="mb-4">
    <p *ngIf="!(formFieldConfigs$ | async)">
      Set configOption for profile form on key member_profile_form_config
    </p>

    <div
      *ngIf="(formFieldConfigs$ | async) && !formConfigValidatorResult?.isValid"
    >
      <p>
        The configOption for organisation form is not valid. Please check the
        config on key organisation_form_config
      </p>
      <p>{{ formConfigValidatorResult?.message }}</p>
    </div>

    <div class="mb-4" *ngIf="formFieldConfigObjects['description'].isVisible">
      <label id="descriptionId" class="form-label">
        {{
          formFieldConfigObjects['description'][
            'title_' + (selectedLanguage$ | async)
          ]
        }}
        <span
          class="small"
          *ngIf="formFieldConfigObjects['description'].isRequired"
          >({{ 'general.required' | translate }})
        </span>
      </label>

      <input
        aria-labelledby="descriptionId"
        aria-describedby="description"
        class="form-control"
        type="text"
        inputmode="text"
        formControlName="description"
        data-test-id="organisation-description-field"
        [required]="formFieldConfigObjects['description'].isRequired"
        [attr.aria-invalid]="
          form.controls.description.dirty && form.controls.description.invalid
            ? 'true'
            : null
        "
      />

      <p
        class="invalid-feedback"
        aria-atomic="true"
        id="description"
        role="alert"
        *ngIf="
          form.controls.description.dirty && form.controls.description.invalid
        "
      >
        {{ 'organizationModule.description' | translate }}
        {{ 'general.isInvalid' | translate }}
      </p>
    </div>

    <div
      class="mb-4"
      *ngIf="formFieldConfigObjects['additionalDescription'].isVisible"
    >
      <label id="additionalDescriptionId" class="form-label">
        {{ getAdditionalDescriptionTitle(selectedLanguage$ | async) }}
        <span
          class="small"
          *ngIf="formFieldConfigObjects['additionalDescription'].isRequired"
          >({{ 'general.required' | translate }})
        </span>
      </label>

      <input
        aria-labelledby="additionalDescriptionId"
        aria-describedby="additionalDescription"
        class="form-control"
        type="text"
        inputmode="text"
        formControlName="additionalDescription"
        data-test-id="organisation-additional-description-field"
        [required]="formFieldConfigObjects['additionalDescription'].isRequired"
        [attr.aria-invalid]="
          form.controls.additionalDescription.dirty &&
          form.controls.additionalDescription.invalid
            ? 'true'
            : null
        "
      />

      <p
        class="invalid-feedback"
        aria-atomic="true"
        id="additionalDescription"
        role="alert"
        *ngIf="
          form.controls.additionalDescription.dirty &&
          form.controls.additionalDescription.invalid
        "
      >
        {{ 'organizationModule.additionalDescription' | translate }}
        {{ 'general.isInvalid' | translate }}
      </p>
    </div>

    <div class="mb-4" *ngIf="formFieldConfigObjects['type'].isVisible">
      <label id="typeId" class="form-label">
        {{
          formFieldConfigObjects['type']['title_' + (selectedLanguage$ | async)]
        }}
        <span class="small" *ngIf="formFieldConfigObjects['type'].isRequired"
          >({{ 'general.required' | translate }})
        </span>
        <i
          class="ms-2 fa fa-question-circle"
          role="button"
          [tooltip]="'memberModule.typeTooltip' | translate"
          tabindex="0"
        >
        </i>
      </label>

      <select
        aria-labelledby="typeId"
        aria-describedby="type"
        formControlName="type"
        class="form-select"
        [required]="formFieldConfigObjects['type'].isRequired"
        [attr.aria-invalid]="
          form.controls.type.dirty && form.controls.type.invalid ? 'true' : null
        "
        data-test-id="organisation-type-select"
      >
        <option
          *ngFor="let type of organizationTypes$ | async"
          [ngValue]="type"
        >
          {{ type }}
        </option>
      </select>

      <p
        class="invalid-feedback"
        aria-atomic="true"
        id="type"
        role="alert"
        *ngIf="form.controls.type.dirty && form.controls.type.invalid"
      >
        {{ 'general.type' | translate }}
        {{ 'general.isInvalid' | translate }}
      </p>
    </div>

    <div class="mb-4" *ngIf="formFieldConfigObjects['email'].isVisible">
      <label id="emailId" class="form-label">
        {{
          formFieldConfigObjects['email'][
            'title_' + (selectedLanguage$ | async)
          ]
        }}
        <span class="small" *ngIf="formFieldConfigObjects['email'].isRequired"
          >({{ 'general.required' | translate }})
        </span>
      </label>

      <input
        aria-labelledby="emailId"
        aria-describedby="email"
        class="form-control"
        [attr.aria-invalid]="
          form.controls.email.dirty && form.controls.email.invalid
            ? 'true'
            : null
        "
        type="email"
        inputmode="email"
        formControlName="email"
        data-test-id="organisation-email-field"
        [required]="formFieldConfigObjects['email'].isRequired"
      />

      <p
        class="invalid-feedback"
        aria-atomic="true"
        id="email"
        role="alert"
        *ngIf="form.controls.email.dirty && form.controls.email.invalid"
      >
        {{ 'general.email' | translate }}
        {{ 'general.isInvalid' | translate }}
      </p>
    </div>

    <div class="mb-4" *ngIf="formFieldConfigObjects['phone'].isVisible">
      <label class="form-label" id="phoneLabel">
        {{
          formFieldConfigObjects['phone'][
            'title_' + (selectedLanguage$ | async)
          ]
        }}
        <span
          id="phoneId"
          class="small"
          *ngIf="formFieldConfigObjects['phone'].isRequired"
          >({{ 'general.required' | translate }})
        </span>
        <i
          class="ms-2 fa fa-question-circle"
          role="button"
          [tooltip]="'memberModule.phoneTooltip' | translate"
          tabindex="0"
        >
        </i>
      </label>

      <input
        class="form-control"
        [placeholder]="countryCallingCode + '612345678'"
        [attr.aria-invalid]="
          form.controls.phone.dirty && form.controls.phone.invalid
            ? 'true'
            : null
        "
        type="tel"
        inputmode="tel"
        formControlName="phone"
        data-test-id="organisation-phone-field"
        attr.aria-label="{{ 'wcag.phonePlaceholder' | translate }}"
        aria-describedby="phone"
        [required]="formFieldConfigObjects['phone'].isRequired"
      />

      <p
        class="invalid-feedback"
        aria-atomic="true"
        id="phone"
        role="alert"
        *ngIf="form.controls.phone.dirty && form.controls.phone.invalid"
      >
        {{ 'general.phone' | translate }}
        {{ 'general.isInvalid' | translate }}
      </p>
    </div>

    <div
      class="mb-4"
      *ngIf="formFieldConfigObjects['parentOrganisationId'].isVisible"
    >
      <label id="organizationSelectionId" class="form-label">
        {{
          formFieldConfigObjects['parentOrganisationId'][
            'title_' + (selectedLanguage$ | async)
          ]
        }}
        <span
          class="small"
          *ngIf="formFieldConfigObjects['parentOrganisationId'].isRequired"
          >({{ 'general.required' | translate }})
        </span>
      </label>

      <custom-select-multiple
        [ariaLabelledby]="'organizationSelectionId'"
        [ariaDescribedby]="'parentOrganisation'"
        id="organization-select-input"
        [selectableItems]="
          organizations$
            | async
            | mapToSelectableItemsPipe
              : 'id'
              : 'description'
              : 'simple'
              : ['commercialCode', 'additionalDescription']
              : ' - '
        "
        [clearable]="true"
        [valueBinder]="'id'"
        [emptyInitValue]="true"
        [loading]="isLoading$ | async"
        [singleSelection]="true"
        [attr.aria-invalid]="
          form.controls.parentOrganisationId.dirty &&
          form.controls.parentOrganisationId.invalid
            ? 'true'
            : null
        "
        [attr.required]="
          formFieldConfigObjects['parentOrganisationId'].isRequired
        "
        (change)="adjustSelectedOrganization($event)"
        (search)="onSearchOrganization($event)"
        [selectDataTestId]="'parent-organisation-select'"
        [optionDataTestId]="'parent-organization-select-option'"
      ></custom-select-multiple>

      <p
        class="invalid-feedback"
        aria-atomic="true"
        id="parentOrganisation"
        role="alert"
        *ngIf="
          form.controls.parentOrganisationId.dirty &&
          form.controls.parentOrganisationId.invalid
        "
      >
        {{ 'general.value' | translate }}
        {{ 'general.isInvalid' | translate }}
      </p>
    </div>

    <div
      class="mb-4"
      *ngIf="formFieldConfigObjects['commercialCode'].isVisible"
    >
      <label id="commercialCodeId" class="form-label">
        {{
          formFieldConfigObjects['commercialCode'][
            'title_' + (selectedLanguage$ | async)
          ]
        }}
        <span
          class="small"
          *ngIf="formFieldConfigObjects['commercialCode'].isRequired"
          >({{ 'general.required' | translate }})
        </span>
        <i
          class="ms-2 fa fa-question-circle"
          role="button"
          [tooltip]="'memberModule.commercialCodeTooltip' | translate"
          tabindex="0"
        ></i>
      </label>

      <input
        aria-labelledby="commercialCodeId"
        aria-describedby="commercialCode"
        class="form-control"
        [required]="formFieldConfigObjects['commercialCode'].isRequired"
        [attr.aria-invalid]="
          form.controls.commercialCode.dirty &&
          form.controls.commercialCode.invalid
            ? 'true'
            : null
        "
        type="text"
        inputmode="text"
        formControlName="commercialCode"
        data-test-id="organisation-comercial-code-field"
      />

      <p
        class="invalid-feedback"
        aria-atomic="true"
        id="commercialCode"
        role="alert"
        *ngIf="
          form.controls.commercialCode.dirty &&
          form.controls.commercialCode.invalid
        "
      >
        {{ 'general.commercialCode' | translate }}
        {{ 'general.isInvalid' | translate }}
      </p>
    </div>

    <div
      class="mb-4"
      *ngIf="formFieldConfigObjects['organisationCode'].isVisible"
    >
      <label id="organisationCodeId" class="form-label">
        {{
          formFieldConfigObjects['organisationCode'][
            'title_' + (selectedLanguage$ | async)
          ]
        }}
        <span
          class="small"
          *ngIf="formFieldConfigObjects['organisationCode'].isRequired"
          >({{ 'general.required' | translate }})
        </span>
        <i
          class="ms-2 fa fa-question-circle"
          role="button"
          [tooltip]="'organizationModule.organizationCodeTooltip' | translate"
          tabindex="0"
        ></i>
      </label>

      <input
        aria-labelledby="organisationCodeId"
        aria-describedby="organisationCode"
        class="form-control"
        [required]="formFieldConfigObjects['organisationCode'].isRequired"
        [attr.aria-invalid]="
          form.controls.organisationCode.dirty &&
          form.controls.organisationCode.invalid
            ? 'true'
            : null
        "
        type="text"
        inputmode="text"
        formControlName="organisationCode"
        data-test-id="organisation-organisation-code-field"
      />

      <p
        class="invalid-feedback"
        aria-atomic="true"
        id="organisationCode"
        role="alert"
        *ngIf="
          form.controls.organisationCode.dirty &&
          form.controls.organisationCode.invalid
        "
      >
        {{ 'organizationModule.organizationCode' | translate }}
        {{ 'general.isInvalid' | translate }}
      </p>
    </div>

    <div class="mb-4" *ngIf="formFieldConfigObjects['website'].isVisible">
      <label id="websiteId" class="form-label">
        {{
          formFieldConfigObjects['website'][
            'title_' + (selectedLanguage$ | async)
          ]
        }}
        <span class="small" *ngIf="formFieldConfigObjects['website'].isRequired"
          >({{ 'general.required' | translate }})
        </span>
        <i
          class="ms-2 fa fa-question-circle"
          role="button"
          [tooltip]="'memberModule.websiteTooltip' | translate"
          tabindex="0"
        ></i>
      </label>

      <input
        aria-labelledby="websiteId"
        aria-describedby="website"
        class="form-control"
        [required]="formFieldConfigObjects['website'].isRequired"
        [attr.aria-invalid]="
          form.controls.website.dirty && form.controls.website.invalid
            ? 'true'
            : null
        "
        type="url"
        inputmode="url"
        formControlName="website"
        data-test-id="organisation-website-field"
      />

      <p
        class="invalid-feedback"
        aria-atomic="true"
        id="website"
        role="alert"
        *ngIf="form.controls.website.dirty && form.controls.website.invalid"
      >
        {{ 'general.website' | translate }}
        {{ 'general.isInvalid' | translate }}
      </p>
    </div>

    <!-- Took out the org code for now will be the VAT number in the future -->
    <!-- <div class="mb-4">
        <div class="d-flex mb-1 align-items-end">
          <label class="form-label" id="oraganizationCodeLabel">
            {{ 'organizationModule.organizationCode' | translate }}
            <i
              class="ms-2 fa fa-question-circle"
              role="button" [tooltip]="
                'organizationModule.organizationCodeTooltip' | translate
              "
              tabindex="0"
            ></i>
          </label>
        </div>
        <div class="position-relative">
          <input
            class="form-control"
            aria-describedby="organizationCode2"
            [attr.aria-invalid]=
                form.controls.organizationCode.dirty &&
                form.controls.organizationCode.invalid
                 ? 'true' : null
            "
            type="text"
            aria-labelledby="oraganizationCodeLabel"
            formControlName="organizationCode"
          />
        </div>
        <p
          class="invalid-feedback" aria-atomic="true" id="organizationCode2" role="alert"
          *ngIf="
            form.controls.organizationCode.dirty &&
            form.controls.organizationCode.invalid
          "
        >
          {{ 'organizationModule.organizationCode' | translate }}
          {{ 'general.isInvalid' | translate }}
        </p>
      </div> -->

    <div
      class="mb-4"
      *ngIf="formFieldConfigObjects['quaternaryCode'].isVisible"
    >
      <label id="quaternaryCodeId" class="form-label">
        {{
          formFieldConfigObjects['quaternaryCode'][
            'title_' + (selectedLanguage$ | async)
          ]
        }}
        <span
          class="small"
          *ngIf="formFieldConfigObjects['quaternaryCode'].isRequired"
          >({{ 'general.required' | translate }})
        </span>
        <i
          class="ms-2 fa fa-question-circle"
          role="button"
          [tooltip]="'organizationModule.quaternaryCodeTooltip' | translate"
          tabindex="0"
        ></i>
      </label>

      <input
        aria-labelledby="quaternaryCodeId"
        aria-describedby="quaternaryCode"
        type="text"
        inputmode="text"
        class="form-control"
        [required]="formFieldConfigObjects['quaternaryCode'].isRequired"
        [attr.aria-invalid]="
          form.controls.quaternaryCode.dirty &&
          form.controls.quaternaryCode.invalid
            ? 'true'
            : null
        "
        formControlName="quaternaryCode"
        data-test-id="organisation-quaternary-code-field"
      />

      <p
        class="invalid-feedback"
        aria-atomic="true"
        id="quaternaryCode"
        role="alert"
        *ngIf="
          form.controls.quaternaryCode.dirty &&
          form.controls.quaternaryCode.invalid
        "
      >
        {{ 'organizationModule.quaternaryCode' | translate }}
        {{ 'general.isInvalid' | translate }}
      </p>
    </div>

    <div
      class="mb-4"
      *ngIf="formFieldConfigObjects['organisationSecondaryCode'].isVisible"
    >
      <label id="organisationSecondaryCodeId" class="form-label">
        {{
          formFieldConfigObjects['organisationSecondaryCode'][
            'title_' + (selectedLanguage$ | async)
          ]
        }}
        <span
          class="small"
          *ngIf="
            formFieldConfigObjects['organisationSecondaryCode'].isRequired ||
            isSecondaryOrgCodeRequired
          "
          >({{ 'general.required' | translate }})
        </span>
      </label>

      <input
        aria-labelledby="organisationSecondaryCodeId"
        aria-describedby="organisationSecondaryCode"
        class="form-control"
        [required]="
          formFieldConfigObjects['organisationSecondaryCode'].isRequired ||
          isSecondaryOrgCodeRequired
        "
        [attr.aria-invalid]="
          form.controls.organisationSecondaryCode.dirty &&
          form.controls.organisationSecondaryCode.invalid
            ? 'true'
            : null
        "
        type="text"
        inputmode="text"
        formControlName="organisationSecondaryCode"
        data-test-id="organisation-secondary-code-field"
      />

      <p
        class="invalid-feedback"
        aria-atomic="true"
        id="organisationSecondaryCode"
        role="alert"
        *ngIf="
          form.controls.organisationSecondaryCode.dirty &&
          form.controls.organisationSecondaryCode.invalid
        "
      >
        {{ 'organizationModule.organizationSecondaryCode' | translate }}
        {{ 'general.isInvalid' | translate }}
      </p>
    </div>

    <div class="mb-4" *ngIf="formFieldConfigObjects['quintaryCode'].isVisible">
      <label id="quintaryCodeId" class="form-label">
        {{
          formFieldConfigObjects['quintaryCode'][
            'title_' + (selectedLanguage$ | async)
          ]
        }}
        <span
          class="small"
          *ngIf="formFieldConfigObjects['quintaryCode'].isRequired"
          >({{ 'general.required' | translate }})
        </span>
        <i
          class="ms-2 fa fa-question-circle"
          role="button"
          [tooltip]="'organizationModule.quintaryCodeTooltip' | translate"
          tabindex="0"
        ></i>
      </label>

      <input
        aria-labelledby="quintaryCodeId"
        aria-describedby="quintaryCode"
        type="text"
        inputmode="text"
        class="form-control"
        [required]="formFieldConfigObjects['quintaryCode'].isRequired"
        [attr.aria-invalid]="
          form.controls.quintaryCode.dirty && form.controls.quintaryCode.invalid
            ? 'true'
            : null
        "
        formControlName="quintaryCode"
        data-test-id="organisation-quintary-code-field"
      />

      <p
        class="invalid-feedback"
        aria-atomic="true"
        id="quintaryCode"
        role="alert"
        *ngIf="
          form.controls.quintaryCode.dirty && form.controls.quintaryCode.invalid
        "
      >
        {{ 'organizationModule.quintaryCode' | translate }}
        {{ 'general.isInvalid' | translate }}
      </p>
    </div>

    <div class="mb-4" *ngIf="formFieldConfigObjects['tertiaryCode'].isVisible">
      <label id="tertiaryCodeId" class="form-label">
        {{
          formFieldConfigObjects['tertiaryCode'][
            'title_' + (selectedLanguage$ | async)
          ]
        }}
        <span
          class="small"
          *ngIf="formFieldConfigObjects['tertiaryCode'].isRequired"
          >({{ 'general.required' | translate }})
        </span>
        <i
          class="ms-2 fa fa-question-circle"
          role="button"
          [tooltip]="'organizationModule.tertiaryCodeTooltip' | translate"
          tabindex="0"
        ></i>
      </label>

      <input
        aria-labelledby="tertiaryCodeId"
        aria-describedby="tertiaryCode"
        type="text"
        inputmode="text"
        class="form-control"
        [required]="formFieldConfigObjects['tertiaryCode'].isRequired"
        [attr.aria-invalid]="
          form.controls.tertiaryCode.dirty && form.controls.tertiaryCode.invalid
            ? 'true'
            : null
        "
        formControlName="tertiaryCode"
        data-test-id="organisation-tertiary-code-field"
      />

      <p
        class="invalid-feedback"
        aria-atomic="true"
        id="tertiaryCode"
        role="alert"
        *ngIf="
          form.controls.tertiaryCode.dirty && form.controls.tertiaryCode.invalid
        "
      >
        {{ 'organizationModule.tertiaryCode' | translate }}
        {{ 'general.isInvalid' | translate }}
      </p>
    </div>

    <fieldset>
      <legend class="h4">{{ 'general.address' | translate }}</legend>
      <div class="mb-4">
        <label class="form-label" id="autocompleteAddressLabel">
          {{ 'pageModule.searchOnAddress' | translate }}</label
        >

        <address-autocomplete
          aria-labelledby="autocompleteAddressLabel"
          (setAddress)="onAddressSearch($event)"
        ></address-autocomplete>
      </div>

      <div class="mb-4" *ngIf="formFieldConfigObjects['street'].isVisible">
        <label id="organisationStreetId" class="form-label">
          {{
            formFieldConfigObjects['street'][
              'title_' + (selectedLanguage$ | async)
            ]
          }}
          <span
            class="small"
            *ngIf="formFieldConfigObjects['street'].isRequired"
            >({{ 'general.required' | translate }})
          </span>
        </label>

        <input
          aria-labelledby="organisationStreetId"
          aria-describedby="street"
          class="form-control"
          type="text"
          inputmode="text"
          formControlName="street"
          [required]="formFieldConfigObjects['street'].isRequired"
          [attr.aria-invalid]="
            form.controls.street.dirty && form.controls.street.invalid
              ? 'true'
              : null
          "
          data-test-id="organisation-street-field"
        />

        <p
          class="invalid-feedback"
          aria-atomic="true"
          id="street"
          role="alert"
          *ngIf="form.controls.street.dirty && form.controls.street.invalid"
        >
          {{ 'general.street' | translate }}
          {{ 'general.isInvalid' | translate }}
        </p>
      </div>

      <div
        class="mb-4"
        *ngIf="formFieldConfigObjects['streetNumber'].isVisible"
      >
        <label id="organisationStreetNumberId" class="form-label">
          {{
            formFieldConfigObjects['streetNumber'][
              'title_' + (selectedLanguage$ | async)
            ]
          }}
          <span
            class="small"
            *ngIf="formFieldConfigObjects['streetNumber'].isRequired"
            >({{ 'general.required' | translate }})
          </span>
        </label>

        <input
          aria-labelledby="organisationStreetNumberId"
          aria-describedby="streetNumber"
          class="form-control"
          type="text"
          inputmode="text"
          formControlName="streetNumber"
          [required]="formFieldConfigObjects['streetNumber'].isRequired"
          [attr.aria-invalid]="
            form.controls.streetNumber.dirty &&
            form.controls.streetNumber.invalid
              ? 'true'
              : null
          "
          data-test-id="organisation-street-number-field"
        />

        <p
          class="invalid-feedback"
          aria-atomic="true"
          id="streetNumber"
          role="alert"
          *ngIf="
            form.controls.streetNumber.dirty &&
            form.controls.streetNumber.invalid
          "
        >
          {{ 'general.houseNr' | translate }}
          {{ 'general.isInvalid' | translate }}
        </p>
      </div>

      <div class="mb-4" *ngIf="formFieldConfigObjects['postbox'].isVisible">
        <label id="organisationPostBoxId" class="form-label">
          {{
            formFieldConfigObjects['postbox'][
              'title_' + (selectedLanguage$ | async)
            ]
          }}
          <span
            class="small"
            *ngIf="formFieldConfigObjects['postbox'].isRequired"
            >({{ 'general.required' | translate }})
          </span>
        </label>

        <input
          aria-labelledby="organisationPostBoxId"
          aria-describedby="postbox"
          class="form-control"
          [required]="formFieldConfigObjects['postbox'].isRequired"
          [attr.aria-invalid]="
            form.controls.postbox.dirty && form.controls.postbox.invalid
              ? 'true'
              : null
          "
          type="text"
          inputmode="text"
          formControlName="postbox"
          data-test-id="organisation-postbox-field"
        />

        <p
          class="invalid-feedback"
          aria-atomic="true"
          id="postbox"
          role="alert"
          *ngIf="form.controls.postbox.dirty && form.controls.postbox.invalid"
        >
          {{ 'general.postboxOrg' | translate }}
          {{ 'general.isInvalid' | translate }}
        </p>
      </div>

      <div class="mb-4" *ngIf="formFieldConfigObjects['city'].isVisible">
        <label id="organisationCityId" class="form-label">
          {{
            formFieldConfigObjects['city'][
              'title_' + (selectedLanguage$ | async)
            ]
          }}
          <span class="small" *ngIf="formFieldConfigObjects['city'].isRequired"
            >({{ 'general.required' | translate }})
          </span>
        </label>

        <input
          aria-labelledby="organisationCityId"
          aria-describedby="city"
          class="form-control"
          [required]="formFieldConfigObjects['city'].isRequired"
          [attr.aria-invalid]="
            form.controls.city.dirty && form.controls.city.invalid
              ? 'true'
              : null
          "
          type="text"
          inputmode="text"
          formControlName="city"
          data-test-id="organisation-city-field"
        />

        <p
          class="invalid-feedback"
          aria-atomic="true"
          id="city"
          role="alert"
          *ngIf="form.controls.city.dirty && form.controls.city.invalid"
        >
          {{ 'general.city' | translate }}
          {{ 'general.isInvalid' | translate }}
        </p>
      </div>

      <div class="mb-4" *ngIf="formFieldConfigObjects['zipCode'].isVisible">
        <label id="organisationZipCodeId" class="form-label">
          {{
            formFieldConfigObjects['zipCode'][
              'title_' + (selectedLanguage$ | async)
            ]
          }}
          <span
            class="small"
            *ngIf="formFieldConfigObjects['zipCode'].isRequired"
            >({{ 'general.required' | translate }})
          </span>
        </label>

        <input
          aria-labelledby="organisationZipCodeId"
          aria-describedby="zipCode"
          class="form-control"
          [required]="formFieldConfigObjects['zipCode'].isRequired"
          [attr.aria-invalid]="
            form.controls.zipCode.dirty && form.controls.zipCode.invalid
              ? 'true'
              : null
          "
          type="text"
          inputmode="text"
          formControlName="zipCode"
          data-test-id="organisation-zipcode-field"
        />

        <p
          class="invalid-feedback"
          aria-atomic="true"
          id="zipCode"
          role="alert"
          *ngIf="form.controls.zipCode.dirty && form.controls.zipCode.invalid"
        >
          {{ 'general.zipcode' | translate }}
          {{ 'general.isInvalid' | translate }}
        </p>
      </div>

      <!-- <div class="mb-4">
        <div class="d-flex mb-1 align-items-end">
          <label class="form-label" id="municipalityLabel">
            {{ 'general.municipality' | translate }}
            <small>({{ 'general.required' | translate | lowercase }})</small>
          </label>
        </div>
        <div class=" position-relative">
          <input
            class="form-control"
            aria-describedby="municipality"
            [attr.aria-invalid]="
                form.controls.municipality.dirty &&
                form.controls.municipality.invalid
                 ? 'true' : null
            "
            type="text"
            aria-labelledby="municipalityLabel"
            formControlName="municipality"
            required
          />
        </div>
        <p
          class="invalid-feedback" aria-atomic="true" id="municipality" role="alert"
          *ngIf="
            form.controls.municipality.dirty &&
            form.controls.municipality.invalid
          "
        >
          {{ 'general.municipality' | translate }}
          {{ 'general.isInvalid' | translate }}
        </p>
      </div> -->

      <!-- <div class="mb-4">
        <div class="d-flex mb-1 align-items-end">
          <label class="form-label" id="regionLabel">
            {{ 'general.region' | translate }}
            <small>({{ 'general.required' | translate | lowercase }})</small>
          </label>
        </div>
        <div class=" position-relative">
          <input
          aria-describedby="region"
            class="form-control"
            [attr.aria-invalid]="
                form.controls.region.dirty && form.controls.region.invalid
                 ? 'true' : null
            "
            type="text"
            aria-labelledby="regionLabel"
            formControlName="region"
            required
          />
        </div>
        <p
          class="invalid-feedback" aria-atomic="true" id="region" role="alert"
          *ngIf="form.controls.region.dirty && form.controls.region.invalid"
        >
          {{ 'general.region' | translate }}
          {{ 'general.isInvalid' | translate }}
        </p>
      </div> -->

      <div class="mb-4" *ngIf="formFieldConfigObjects['country'].isVisible">
        <label id="countryId" class="form-label">
          {{
            formFieldConfigObjects['country'][
              'title_' + (selectedLanguage$ | async)
            ]
          }}
          <span
            class="small"
            *ngIf="formFieldConfigObjects['country'].isRequired"
            >({{ 'general.required' | translate }})
          </span>
        </label>

        <select
          aria-labelledby="countryId"
          aria-describedby="country"
          formControlName="country"
          [attr.aria-invalid]="
            form.controls.country.dirty && form.controls.country.invalid
              ? 'true'
              : null
          "
          class="form-select"
          data-test-id="organisation-country-select"
          required
        >
          <option [ngValue]="null" selected>
            {{ 'general.select' | translate }}
          </option>
          <option
            *ngFor="let availableCountry of availableCountries"
            [value]="availableCountry.ISO3166CountryCode"
          >
            {{ 'countries.' + availableCountry.ISO3166CountryCode | translate }}
          </option>
        </select>

        <p
          class="invalid-feedback"
          aria-atomic="true"
          id="country"
          role="alert"
          *ngIf="form.controls.country.dirty && form.controls.country.invalid"
        >
          {{ 'general.country' | translate }}
          {{ 'general.isInvalid' | translate }}
        </p>
      </div>
    </fieldset>
  </div>
  <!-- TODO: remove col-sm-8 when adding back profile image -->
  <div class="form-footer text-end">
    <div
      class="spinner-border"
      role="status"
      *ngIf="isLoading$ | async"
      attr.aria-label="{{ 'wcag.loading' | translate }}"
    ></div>
    <button
      class="btn btn-primary"
      type="submit"
      [disabled]="!form.dirty || (isLoading$ | async)"
      data-test-id="organisation-save-button"
    >
      {{ 'general.save' | translate }}
    </button>
  </div>
</form>
